import { Breadcrumbs } from 'components/breadcrumbs';
import { Container } from 'components/container';
import PreLoading from 'components/pre-loading';
import { GradiantText } from 'components/text';
import { Section } from './index.styled';
import SocialLinks from 'components/social';
import { GMap } from 'primereact/gmap';
import { loadGoogleMaps, removeGoogleMaps } from '../../utils/GoogleMaps';
import { useEffect, useState } from 'react';
import HubspotForm from 'react-hubspot-form';

const ContactPage = () => {
  const [googleMapsReady, setGoogleMapsReady] = useState(false);

  const options = {
    center: { lat: 30.393830642155258, lng: -97.84779527746473 },
    zoom: 15,
  };

  useEffect(() => {
    loadGoogleMaps(() => {
      setGoogleMapsReady(true);
    });

    return () => {
      removeGoogleMaps();
    };
  }, []);

  return (
    <Section>
      <PreLoading label="CONTACT" />
      <Breadcrumbs
        className="breadcrumbs"
        label="CONTACT US"
        text="Build your Online decentralized commerce strategy today!"
      />
      <div className="main">
        <Container>
          <div className="grid">
            <div className="col-12 md:col-6">
              <GradiantText>Get In Touch.</GradiantText>
              <HubspotForm
                portalId="7175493"
                formId="149a8fb8-b1e3-4ade-bb35-26eaa69bd5c8"
                onSubmit={() => console.log('Submit!')}
                loading={<div>Loading...</div>}
              />
            </div>
            <div className="col-12 md:col-5 md:col-offset-1 mt-5 md:mt-0">
              <GradiantText>Contact Info.</GradiantText>
              <h5>Let'sTalk.</h5>
              <p>support@crwd.id</p>
              <p>+1.512.767.1773</p>

              <h5 className="second">VisitUs.</h5>
              <p>80 S.W. 8th Street, Suite 2000</p>
              <p>Miami, Florida USA</p>

              <SocialLinks className="social" />
            </div>
          </div>
        </Container>
      </div>
      <div className="map-wrapper">
        {googleMapsReady && (
          <GMap
            options={options}
            overlays={[
              new google.maps.Marker({
                position: { lat: options.center.lat, lng: options.center.lng },
                title: 'CrowdPoint Technologies',
              }),
            ]}
          />
        )}
      </div>
    </Section>
  );
};
export default ContactPage;
